<template>
  <card class="pc-distributed-item" dis-hover :padding="8">
    <div class="pc-distributed-item-content">
      <div class="pc-distributed-item-info">
        <span class="ms-text">{{ payment.contract.code }}</span>
        <span class="ms-help">
          {{ payment.act_id ? `Акт №${payment.act.number}` : 'Аванс' }}
        </span>
      </div>
      <div class="pc-distributed-item-costs">
        <tag color="primary" class="ms-costs">
          {{ getFormattedCosts(payment.value, true) }} руб.
        </tag>
      </div>
    </div>
  </card>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFormattedCosts
  }
}
</script>

<style lang="less">
.pc-distributed-item {
  &:not(:first-child) {
    margin-top: 8px;
  }

  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-info {
    margin-right: 16px;

    .ms-help {
      margin-left: 16px;
    }
  }

  &-costs {
    .ivu-tag {
      margin: 0 !important;
      width: 182px !important;
    }
  }
}
</style>
